import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { environment } from 'src/environments/environment';
import { PlatformSectionService } from './platform-section.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { AddPlatformSectionComponent } from './add-platform-section/add-platform-section.component';
import { EditPlatformSectionComponent } from './edit-platform-section/edit-platform-section.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-platform-section',
  templateUrl: './platform-section.component.html',
  styleUrls: ['./platform-section.component.scss'],
})
export class PlatformSectionComponent {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  isLoading = false;

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  dtLink =
    environment.interop.basePath +
    environment.interop.urbanism.nomenclatoare.platformSection
      .getPlatformSectionsDT;

  dataTablesParameters: any = {
    data: {
      key: 'parameter',
    },
  };

  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private platformSectionService: PlatformSectionService
  ) {}

  ngOnInit(): void {
    this.renderDT();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next('');
  }

  renderDT() {
    this.isLoading = true;
    this.dtOptions = {
      serverSide: true, // Set the flag
      ajax: (dataTablesParameters: any, callback: any) => {
        // Adding custom parameters to the dataTablesParameters object
        dataTablesParameters.param1 = 'value1';
        dataTablesParameters.param2 = 'value2';
        dataTablesParameters.param3 = 'value3';

        this.http
          .post<DataTablesResponse>(
            this.dtLink, // datatable link, we need this
            dataTablesParameters // parameters for filtering, send here
          )
          .subscribe((resp: any) => {
            this.isLoading = false;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: resp.data.data,
            });
          });
      },
      language: environment.config.romanianLanguageDataTable,
      columns: [
        {
          title: 'ID',
          data: 'id',
        },
        {
          title: 'Nume',
          data: 'name',
        },
        {
          title: 'Slug',
          data: 'slug',
        },
        {
          title: 'Acțiuni',
          orderable: false,
          render: () => {
            return `
              <button class="action-btn edit">
                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
              </button>
              <button class="action-btn delete">
                <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
              </button>
            `;
          },
        },
      ],
      rowCallback: (row: Node, data: any[] | any) => {
        const lastTd = (row as HTMLElement).querySelector('td:last-child');
        const editIcon = lastTd?.querySelector('.edit');
        const deleteIcon = lastTd?.querySelector('.delete');

        if (editIcon) {
          editIcon.addEventListener('click', () => {
            this.openEditDialog(data);
          });
        }

        if (deleteIcon) {
          deleteIcon.addEventListener('click', () => {
            const { id } = data;
            this.deletePlatformSection(id);
          });
        }

        return row;
      },
    };
  }

  rerenderDT(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next('');
    });
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(AddPlatformSectionComponent, {
      ...this.dialogService.getDialogConfig(),
    });

    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.rerenderDT();
      }
    });
  }

  openEditDialog(data: any) {
    const dialogRef = this.dialog.open(EditPlatformSectionComponent, {
      ...this.dialogService.getDialogConfig(),
      data,
    });

    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.rerenderDT();
      }
    });
  }

  deletePlatformSection(platformSectionId: number) {
    Swal.fire({
      title: 'Sunteți sigur?',
      text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Confirm!',
      cancelButtonText: 'Anulare',
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.platformSectionService
          .deletePlatformSection(platformSectionId)
          .subscribe(() => {
            this.rerenderDT();
            Swal.fire({
              title: 'Șters!',
              text: 'Secțiune ștearsă cu succes.',
              icon: 'success',
              confirmButtonText: 'OK',
            });
          });
      }
    });
  }
}
